<template>
  <div class="artists-related section">
    <h2>{{ $t('artistsEvent.artistas') }}</h2>
    <div class="separator" />
    <slider :type="'artist'"
            :elements="artistsEvent" />
  </div>
</template>
<script>
import Slider from '@/components/slider/Slider.vue'
export default {
  components: {
    Slider
  },
  props: {
    artistsEvent: {
      type: Array,
      default: () => []
    }
  }
}
</script>
